export type ApiError = { error?: { code?: string; message?: string; requestId?: string } }

let csrfToken = ''

export function setCsrfToken(value?: string) {
  csrfToken = value || ''
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers)
  if (options.body && !headers.has('content-type')) headers.set('content-type', 'application/json')
  if (csrfToken && options.method && !['GET', 'HEAD'].includes(options.method)) headers.set('x-csrf-token', csrfToken)
  const response = await fetch(path, { credentials: 'same-origin', ...options, headers })
  if (response.status === 204) return undefined as T
  const body = await response.json().catch(() => ({})) as T & ApiError
  if (!response.ok) throw Object.assign(new Error(body.error?.message || `Request failed (${response.status})`), { code: body.error?.code, status: response.status })
  return body
}

export function jsonBody(value: unknown) {
  return JSON.stringify(value)
}
